import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import DocumentValidateModel from "../../models/document-validate";

export default class DocumentValidateRepository extends BaseRepository {
  static modelClass = DocumentValidateModel;
  modelName = "document-validate";
}
